import { unwatchFile } from "fs";

//提现状态
let yesNo = (status) => {
    if (status == '1') {
        return "是";
    }
    if (status == '0') {
        return "否";
    }
}
//日志 type
let logTypeName = (type) => {
    if (type == '1') {
        return "登录";
    }
    if (type == '2') {
        return "登出";
    }
    if (type == '3') {
        return "其他";
    }
}
//登录状态
let loginFlagName  = (loginFlag) => {
    if (loginFlag == '1') {
        return "可用";
    }
    if (loginFlag == '0') {
        return "禁用";
    }
}
//角色类型
let roleTypeName  = (roleType) => {
    if(roleType == null){
        return "系统管理员";
    }
    if (roleType == '1') {
        return "营业部";
    }
    if (roleType == '2') {
        return "分公司";
    }
}
//启用/停用
let useStatus  = (useStatus) => {
    if (useStatus == '1') {
        return "启用";
    }
    if (useStatus == '0') {
        return "停用";
    }
}
export { yesNo, logTypeName , loginFlagName, roleTypeName, useStatus}



// WEBPACK FOOTER //
// ./src/assets/js/typefilter.js